
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class HeaderService {
  private baseUrl: string;
  SSO: any;

  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
  }


  // Method to get the Announcement Details
  // getAnnouncement(): Observable<any[]> {
  //   return this.http.get<any[]>(`${this.baseUrl}/announcement`)
  //     .pipe(
  //       map(response => response as any[]),
  //       catchError(handleError)
  //     );
  // }
}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return observableThrowError(errorMsg);
}
